import { useParams } from 'react-router-dom';
import React, { useContext, useEffect, useState } from 'react';
import { CaseTabContext } from 'app/edozvola/cases/case-form-wrapper';
import {
  checkAmendmentCaseActAndTemplateExistsQuery,
  previewAmendmentCaseActWorkingVersionFileWithDefaultTemplateQuery,
} from 'app/edozvola/cases/case-acts/service/case-acts.queries';
import { Button } from 'edozvola-frontend-lib/dist/ui';
import CaseActsConfirmationModal from 'app/edozvola/cases/case-acts/case-acts-confirmation-modal';
import CaseActsTable from 'app/edozvola/cases/case-acts/case-acts-table';
import { Loader } from 'app/shared/loader/loader';

const AmendmentActs = () => {
  const { id: uuid } = useParams<{ id: string }>();
  const { sidebarItemPair } = useContext(CaseTabContext);
  const [confirmActionModalShown, setConfirmActionModalShown] = useState<boolean>(false);
  const [shouldHideActionButtons, setShouldHideActionButtons] = useState<boolean>(false);

  const { data: caseActAndTemplateExists, isLoading: isCheckingLoading } = checkAmendmentCaseActAndTemplateExistsQuery(uuid);
  const { mutate: previewCaseActMutation, isPending } = previewAmendmentCaseActWorkingVersionFileWithDefaultTemplateQuery(uuid);

  useEffect(() => {
    setShouldHideActionButtons(caseActAndTemplateExists !== true);
  }, [caseActAndTemplateExists]);

  const onCreateDocumentClicked = () => {
    setConfirmActionModalShown(true);
  };

  const onPreviewDocumentClicked = () => {
    previewCaseActMutation();
  };
  const handleConfirmation = (idCaseAct: number) => {
    if (!isCheckingLoading && idCaseAct !== null) {
      setShouldHideActionButtons(true);
    }
  };

  return (
    <>
      {isCheckingLoading && <Loader />}
      {!isCheckingLoading && (
        <div className={'d-flex justify-content-between'}>
          {!sidebarItemPair?.readOnly && !shouldHideActionButtons && (
            <Button
              label={'Pregledaj dokument'}
              disabled={isPending || confirmActionModalShown}
              color="secondary"
              size="lg"
              onClick={() => onPreviewDocumentClicked()}
            ></Button>
          )}
          {!sidebarItemPair?.readOnly && !shouldHideActionButtons && (
            <>
              <Button label="Izradi dokument dopune" disabled={isPending} color="info" size="lg" onClick={() => onCreateDocumentClicked()} />
              <CaseActsConfirmationModal
                uuid={uuid}
                confirmActionModalShown={confirmActionModalShown}
                setConfirmActionModalShown={setConfirmActionModalShown}
                readOnly={false}
                onConfirmed={handleConfirmation}
                header={'Izrada dokumenta dopune zahtjeva'}
                bodyMessage={
                  'Izrada dokumenta dopune zahtjeva je posljednji korak prije predaje dopune. Nakon što izradite dokument dopune zahtjeva, isti nećete moći izmijeniti ili izbrisati. Jeste li sigurni da želite izraditi dokument dopune zahtjeva?'
                }
                isAmendment
              />
            </>
          )}
        </div>
      )}
      <div className={'mt-3'}>
        <CaseActsTable onRowClick={onCreateDocumentClicked} tableMessage={'Dokument dopune zahtjeva nije izrađen.'} />
      </div>
    </>
  );
};

export default AmendmentActs;
